module.exports = __webpack_public_path__ + "img/BMW_Grey-Colour_RGB3.f8495867.png";